import React, { useEffect, useRef, useState } from "react";
import getText from "Translator";
import Swal from "sweetalert2";
import {
  Checkbox,
  Divider,
  FormControlLabel,
  Grid,
  IconButton,
  InputBase,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Paper,
  Typography,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import StarBorderIcon from "@mui/icons-material/StarBorder";
import { useMaterialUIController } from "context";
import { displayErrorMessage } from "controllers/validation";
import {
  setDateMode,
  setNotification,
  setAction,
  setFavorite,
  setLang,
  setTitle,
  setHeader,
} from "context";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { updateLang } from "controllers/UserController";
import { storeAccountFavorite } from "controllers/UserController";
import { updateDateMode } from "controllers/UserController";
import { getUnreadedNotifications } from "controllers/NotificationController";
import { getNewMenu } from "controllers/MenuController";
import { StoreFile } from "controllers/FileController";
import { useNavigate, useParams } from "react-router-dom";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import { setLoading } from "context";
import { setLogout } from "context";

let SourceMenu = [];

export default function MainMenuView(props) {
  const [controller, dispatch] = useMaterialUIController();

  const [menu, setMenu] = useState();
  const [open, setOpen] = useState();
  const [open1, setOpen1] = useState();
  const [open2, setOpen2] = useState(false);
  const [, setCap] = useState();
  const [, setReload] = useState(new Date());
  const navigate = useNavigate();
  // const classes = useStyles();
  const [search, setSearch] = useState("");
  const [searchDisplay, setSearchDisplay] = useState(false);
  const myRef = useRef(null);
  const { headline } = useParams();
  const menuFavoritekHandler = async (item) => {
    try {
      let result = await storeAccountFavorite({ id: item.id }, controller);
      if (result.success) {
        getMenu();
        Swal.fire({
          text: item.favorite
            ? getText("outfavorite", "fa")
            : getText("infavorite", "fa"),
          position: "bottom-end",
          background: "#03fca1",
          showConfirmButton: false,
          timer: 1500,
        });
      } else {
      }
    } catch (err) {
      console.log(err);
    }
  };
  const newMenu = () => {
    return (
      <>
        {menu?.map((item) => (
          <>
            <ListItem
              key={item.id}
              onClick={async () => {
                if (item.id === "files") {
                  // await localStorage.setItem("$menu", JSON.stringify(menuDB));
                  navigate("/myfiles/");
                } else {
                  if (item.id + "" == open + "") {
                    setOpen();
                  } else {
                    setOpen(item.id);
                    let menuDB = await localStorage.getItem("$menu");
                    if ((menuDB + "").length > 10) {
                      menuDB = JSON.parse(menuDB);
                      menuDB.headline = item.id;
                      menuDB.headlineText = item.text;
                    } else {
                      menuDB = {
                        headline: item.id,
                        headlineText: item.text,
                      };
                    }
                    await localStorage.setItem("$menu", JSON.stringify(menuDB));
                  }
                }
              }}
              alignItems="flex-start"
              style={{
                height: 40,
                cursor: "pointer",
                // backgroundColor:
                //   item.id + "" == open + ""
                //     ? "RGBA(176, 176, 176, 0.7)"
                //     : "transparent",
              }}
            >
              <ListItemText
                primary={
                  <Typography
                    variant="inherit"
                    style={{
                      color: "#039dfc",
                      fontWeight: "bold",
                      fontSize: 14,
                    }}
                  >
                    {item.text}
                  </Typography>
                }
              />

              {item.id !== "files" && item.id == open && (
                <KeyboardArrowDownIcon style={{ color: "rgb(229 166 161)" }} />
              )}
              {item.id !== "files" && item.id !== open && item.open !== true && (
                <>
                  {"fa" == "fa" && (
                    <KeyboardArrowLeftIcon style={{ color: "#039dfc" }} />
                  )}
                  {"fa" == "en" && (
                    <KeyboardArrowRightIcon style={{ color: "#039dfc" }} />
                  )}
                </>
              )}
            </ListItem>
            {open &&
              open == item.id &&
              menu
                .filter((a) => a.id + "" == open + "")[0]
                .title.map((sitem) => (
                  <div key={`${sitem.id}_divs`}>
                    <ListItem
                      key={sitem.id}
                      style={{
                        height: 40,
                        cursor: "pointer",
                        paddingLeft: 10,
                        paddingRight: 10,
                        // backgroundColor:
                        //   sitem.id + "" == open1 + ""
                        //     ? "RGBA(245, 245, 245, 0.7)"
                        //     : "transparent",
                      }}
                    >
                      {controller.authenticated && (
                        <ListItemIcon
                          style={{ width: 35, minWidth: 35 }}
                          onClick={() => {
                            menuFavoritekHandler(sitem);
                          }}
                        >
                          <StarBorderIcon
                            style={{
                              fontSize: 17,
                              color: sitem.favorite ? "#fc9d03" : "#039dfc",
                            }}
                          />
                        </ListItemIcon>
                      )}
                      <ListItemText
                        button={true}
                        onClick={() => {
                          if (sitem.id + "" == open1 + "") {
                            setOpen1();
                          } else {
                            setOpen1(sitem.id);
                            let x = menu.filter(
                              (a) => a.id + "" == open + ""
                            )[0].title;
                            x = x.filter((a) => a.id + "" == sitem.id + "")[0]
                              .capsule;
                            setCap(x);
                          }
                        }}
                        primary={
                          <Typography
                            variant="inherit"
                            style={{
                              color: "#039dfc",
                              fontWeight: "bold",
                              fontSize: 13,
                            }}
                          >
                            {sitem.text}
                          </Typography>
                        }
                      />
                      {(open1 == sitem.id ||
                        (open == item.id && sitem.capsule.length == 1)) && (
                        <KeyboardArrowDownIcon style={{ color: "#fcaaa4" }} />
                      )}
                      {!(
                        open1 == sitem.id ||
                        (open == item.id && sitem.capsule.length == 1)
                      ) && (
                        <>
                          {controller.direction == "rtl" && (
                            <KeyboardArrowLeftIcon
                              style={{ color: "#039dfc" }}
                            />
                          )}
                          {controller.direction == "ltr" && (
                            <KeyboardArrowRightIcon
                              style={{ color: "#039dfc" }}
                            />
                          )}
                        </>
                      )}
                    </ListItem>

                    {sitem.capsule &&
                      (open1 == sitem.id ||
                        (open == item.id && sitem.capsule.length == 1)) &&
                      sitem.capsule.map((citem) => (
                        <ListItem
                          id="mainMenuId"
                          key={citem.id}
                          style={{
                            paddingLeft: 15,
                            paddingRight: 15,
                            lineHeight: 2,
                          }}
                        >
                          {controller.authenticated && (
                            <ListItemIcon
                              style={{ width: 35, minWidth: 35 }}
                              onClick={() => {
                                menuFavoritekHandler(citem);
                              }}
                            >
                              <StarBorderIcon
                                style={{
                                  fontSize: 17,
                                  color: citem.favorite ? "#fc9d03" : "#039dfc",
                                }}
                              />
                            </ListItemIcon>
                          )}
                          <ListItemText
                            onClick={() => {
                              menuClickHandler(item, citem);
                            }}
                            button={true}
                            primary={
                              <Typography
                                variant="inherit"
                                style={{ color: "#039dfc", fontSize: 14 }}
                              >
                                {citem.text}
                              </Typography>
                            }
                          />
                          {item.id == "complaints" && (
                            <div
                              style={{
                                borderWidth: 2,
                                borderColor: "#039dfc",
                                minWidth: 40,
                                height: 22,
                                borderRadius: 15,
                                backgroundColor: "#039dfc",
                                fontWeight: "bold",
                                verticalAlign: "center",
                                fontSize: 14,
                                color: "#FFF",
                                textAlign: "center",
                                marginInlineEnd: 8,
                              }}
                            >
                              {citem.filesCount}
                            </div>
                          )}
                        </ListItem>
                      ))}
                  </div>
                ))}
            <Divider />
          </>
        ))}
      </>
    );
  };
  const renderSettingsMenu = () => {
    return (
      <>
        <ListItem
          style={{
            height: 40,
            cursor: "pointer",
            //backgroundColor: open2 ? "RGBA(176, 176, 176, 0.7)" : "transparent",
          }}
          onClick={() => {
            setOpen2(!open2);
          }}
        >
          <ListItemText
            primary={
              <Typography
                variant="inherit"
                style={{ color: "#039dfc", fontSize: 14, fontWeight: "bold" }}
              >
                {getText("setting", "fa")}
              </Typography>
            }
          />
          {open2 && <KeyboardArrowDownIcon style={{ color: "#fcaaa4" }} />}
          {!open2 && (
            <>
              {controller.direction == "rtl" && (
                <KeyboardArrowLeftIcon style={{ color: "#039dfc" }} />
              )}
              {controller.direction == "ltr" && (
                <KeyboardArrowRightIcon style={{ color: "#039dfc" }} />
              )}
            </>
          )}
        </ListItem>
        {open2 && (
          <>
            {/* <Grid
              container
              style={{
                height: 50,
                paddingInlineStart: 20,
                paddingTop: 5,
                backgroundColor: "RGBA(245, 245, 245, 0.7)",
              }}
            >
              <Grid item xs={4} sm={4} md={4}>
                <ListItemText
                  primary={
                    <Typography
                      variant="inherit"
                      style={{
                        color: "#039dfc",
                        fontSize: 14,
                        fontWeight: "bold",
                      }}
                    >
                      {getText("datemode", "fa")}
                    </Typography>
                  }
                />
              </Grid>
              <Grid item xs={4} sm={4} md={4}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={controller.dateMode == "fa" ? true : false}
                    />
                  }
                  label="شمسی"
                  onClick={async () => {
                    let newData = {
                      dateMode: "fa",
                    };

                    setLoading(dispatch, true);
                    let result = await updateDateMode(newData, controller);
                    if (result.success) {
                      setDateMode(dispatch, "fa");
                      Swal.fire({
                        text: getText("alertsuccess", "fa"),
                        position: "bottom-end",
                        background: "#03fca1",
                        showConfirmButton: false,
                        timer: 1500,
                      });
                    } else {
                      Swal.fire({
                        text: getText("warningalert", "fa"),
                        position: "bottom-end",
                        background: "#f1b3af",
                        showConfirmButton: false,
                        timer: 1500,
                      });
                    }

                    setLoading(dispatch, false);
                    setOpen(false);
                  }}
                />
              </Grid>
              <Grid item xs={4} sm={4} md={4}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={controller.dateMode == "en" ? true : false}
                    />
                  }
                  label="English"
                  onClick={async () => {
                    let newData = {
                      dateMode: "en",
                    };

                    setLoading(dispatch, true);
                    let result = await updateDateMode(newData, controller);
                    if (result.success) {
                      setDateMode(dispatch, "en");
                      Swal.fire({
                        text: getText("alertsuccess", "fa"),
                        position: "bottom-end",
                        background: "#03fca1",
                        showConfirmButton: false,
                        timer: 1500,
                      });
                    } else {
                      Swal.fire({
                        text: getText("warningalert", "fa"),
                        position: "bottom-end",
                        background: "#f1b3af",
                        showConfirmButton: false,
                        timer: 1500,
                      });
                    }

                    setLoading(dispatch, false);
                    setOpen(false);
                  }}
                />
              </Grid>
            </Grid>

            <Grid
              container
              style={{
                height: 50,
                paddingInlineStart: 20,
                paddingTop: 5,
                backgroundColor: "RGBA(245, 245, 245, 0.7)",
              }}
            >
              <Grid item xs={4} sm={4} md={4}>
                <ListItemText
                  primary={
                    <Typography
                      variant="inherit"
                      style={{
                        color: "#039dfc",
                        fontSize: 14,
                        fontWeight: "bold",
                      }}
                    >
                      {getText("changelang", "fa")}
                    </Typography>
                  }
                />
              </Grid>
              <Grid item xs={4} sm={4} md={4}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={"fa" == "fa" ? true : false}
                    />
                  }
                  label="فارسی"
                  onClick={() => {
                    let newData = {
                      lang: "fa",
                    };
                    updateLang(newData, controller);

                    setLang(dispatch, { lang: "fa", direction: "rtl" });
                    setTitle(dispatch, {
                      title: getText("setting", "fa"),
                      subtitle: "",
                    });

                    window.location.reload();
                  }}
                />
              </Grid>
              <Grid item xs={4} sm={4} md={4}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={"fa" == "en" ? true : false}
                    />
                  }
                  label="English"
                  onClick={async () => {
                    let newData = {
                      lang: "en",
                    };
                    let result = await updateLang(newData, controller);
                    if (result.success) {
                      setLang(dispatch, { lang: "en", direction: "ltr" });

                      setTitle(dispatch, {
                        title: getText("iclc", "fa"),
                        subTitle: "",
                      });
                      setHeader(dispatch, "");

                      Swal.fire({
                        text: getText("alertsuccess", "fa"),
                        position: "bottom-end",
                        background: "#03fca1",
                        showConfirmButton: false,
                        timer: 1500,
                      });
                      window.location.reload();
                    } else {
                      Swal.fire({
                        text: getText("warningalert", "fa"),
                        position: "bottom-end",
                        background: "#f1b3af",
                        showConfirmButton: false,
                        timer: 1500,
                      });
                    }
                  }}
                />
              </Grid>
            </Grid> */}

            <ListItem
              style={{
                height: 50,

                paddingInlineStart: 20,
              }}
              button
              onClick={() => {
                navigate("/profile");
              }}
            >
              <ListItemText
                primary={
                  <Typography
                    variant="inherit"
                    style={{
                      color: "#039dfc",
                      fontSize: 14,
                      fontWeight: "bold",
                    }}
                  >
                    {getText("profile", "fa")}
                  </Typography>
                }
              />
            </ListItem>
            <ListItem
              style={{
                height: 50,

                paddingInlineStart: 20,
              }}
              button
              onClick={() => {
                setLogout(dispatch, controller);
                window.location.reload();
              }}
            >
              <ListItemText
                primary={
                  <Typography
                    variant="inherit"
                    style={{
                      color: "#039dfc",
                      fontSize: 14,
                      fontWeight: "bold",
                    }}
                  >
                    {getText("exit", "fa")}
                  </Typography>
                }
              />
            </ListItem>
          </>
        )}
        <Divider />
      </>
    );
  };

  const setNotificationCount = async () => {
    try {
      if (controller.authenticated) {
        let result = await getUnreadedNotifications(controller);
        if (result.success) {
          if (result.data !== controller.notification) {
            setNotification(dispatch, result.data);
          }
        } else {
        }
      }
    } catch (err) {}
  };
  useEffect(() => {
    if (!controller.name && controller.id !== "") {
      Swal.fire({
        title: getText("warning", "fa"),
        text: getText("completeprofile", "fa"),
        confirmButtonText: getText("ok", "fa"),
      });
      navigate("/profile");
      return;
    }
    getMenu();
    return () => {
      setNotificationCount();

      setAction(dispatch, "");
      setHeader(dispatch, "");

      setLoading(dispatch, false);
    };
  }, []);
  useEffect(() => {
    (async () => {
      setNotificationCount();
      if (controller.action) {
        if (controller.action.startsWith("favorite")) {
          await changeFavorite();
          setSearchDisplay(false);
        } else if (controller.action.startsWith("search")) {
          if (searchDisplay) {
            setSearch("");

            /////////setMenu(SourceMenu);
          }

          setSearchDisplay(!searchDisplay);
        }
        setAction(dispatch, "");
      }
    })();
  }, [controller.action]);
  const changeFavorite = async () => {
    let newFav = !controller.favorite;
    setFavorite(dispatch, newFav);
    setAction(dispatch, "");
    window.location.reload();
    //}
  };
  const getMenu = async (fav) => {
    try {
      setHeader(dispatch, "search-favorite");
      setTitle(dispatch, {
        title: getText("iclc", "fa"),
        subtitle: "",
      });
      setLoading(dispatch, true);

      let data = {
        favorite: fav ? fav : controller.favorite,
        lang: "fa",
      };
      let newMenu = await getNewMenu(data, controller);
      console.log("newMenu",newMenu.success, "x-" + controller.id + "-", newMenu);
      if (newMenu.success) {
        console.log("newMenuccc", newMenu);
        setMenu([]);
        setMenu(newMenu.data);
        newMenu.data.forEach((item) => {
          if (!open && item.open) {
            setOpen(item.id);
          }
        });

        SourceMenu = JSON.stringify(newMenu.data);

        setReload(new Date());
      } else {
        displayErrorMessage("fa");
        setLoading(dispatch, false);
        return;
      }

      setLoading(dispatch, false);
    } catch (err) {
      console.log(err);
      setLoading(dispatch, false);
      displayErrorMessage("fa");
    }
  };
  const menuClickHandler = async (item, selectedCapsule) => {
    try {
      let seletedTitle = item.title.filter(
        (a) => a.id == selectedCapsule.title
      )[0];
      let menu = await localStorage.getItem("$menu");
      menu = JSON.parse(menu);

      if (item.id === "diseases" || item.id === "scores") {
        let savedFile;
        let file = "";
        if (props.file) {
          file = props.file;
        }
        let newFile = {
          file,
          headline: item.id,
          capsule: selectedCapsule.id,
          patientName: "",
          patientFamily: "",
          title: seletedTitle.id,
          showInForum: false,
          summary: "",
          showInForumAdmin: false,
          sendToServer: false,
          myquestion: "",
          sendToForumDate: new Date(),
          patientNationalCode: "",
          visible: true,
          birthDate: "",
          gender: -1,
          fatherName: "",
          from: "menu",
          file: file,
          Account: controller.id,
        };
        savedFile = await StoreFile(newFile, controller);
        console.log("savedFile", savedFile);
        if (savedFile.success) {
          let menuDB = await localStorage.getItem("$menu");
          if ((menuDB + "").length > 10) {
            menuDB = JSON.parse(menuDB);
            menuDB.file = savedFile.data._id;
            menuDB.nationalCode = "";
            menuDB.birthYear = "";
            menuDB.showResultOfFile = false;
            menuDB.isMyFile = true;
            menuDB.limitedFile = false;
            menuDB.capsule = selectedCapsule.id;
            menuDB.capsuleText = selectedCapsule.text;
            menuDB.title = seletedTitle.id;
            menuDB.titleText = seletedTitle.text;
            menuDB.from = "menu";
            menuDB.visitedpageslist = [];
          } else {
            menuDB = {
              file: savedFile.data._id,
              nationalCode: "",
              birthYear: "",
              showResultOfFile: false,
              isMyFile: true,
              limitedFile: false,
              capsule: selectedCapsule.id,
              capsuleText: selectedCapsule.text,
              title: seletedTitle.id,
              titleText: seletedTitle.text,
              from: "menu",
              visitedpageslist: [],
            };
          }
          await localStorage.setItem("$menu", JSON.stringify(menuDB));
          navigate("/pageview");
        } else {
          Swal.fire({
            title: getText("warning", "fa"),
            text: savedFile.message,
            confirmButtonText: getText("ok", "fa"),
          });
        }
        return;
      } else if (item.id === "forums") {
        let menuDB = await localStorage.getItem("$menu");
        if ((menuDB + "").length > 10) {
          menuDB = JSON.parse(menuDB);
          menuDB.file = "";
          menuDB.openFrom = "";
          menuDB.capsule = selectedCapsule.id;
          menuDB.capsuleText = selectedCapsule.text;
        } else {
          menuDB = {
            file: "",
            openFrom: "",
            capsule: selectedCapsule.id,
            capsuleText: selectedCapsule.text,
          };
        }
        await localStorage.setItem("$menu", JSON.stringify(menuDB));
        navigate("/chatroom");

        return;
      } else if (item.id === "complaints") {
        let menuDB = await localStorage.getItem("$menu");
        console.log(
          "selectedCapsuleselectedCapsule",
          selectedCapsule,
          seletedTitle
        );
        menuDB = JSON.parse(menuDB);
        menuDB.capsule = selectedCapsule.id;
        menuDB.capsuleText = selectedCapsule.text;
        menuDB.title = seletedTitle.id;
        menuDB.titleText = seletedTitle.text;
        menuDB.from = "menu";

        await localStorage.setItem("$menu", JSON.stringify(menuDB));
        // navigate("/files/" + menuDB.headline + "/" + menuDB.headlineText);
        navigate("/files/");
      }

      return;
    } catch (err) {
      console.log(err);
      Swal.fire({
        title: getText("warning", "fa"),
        text: getText("generalerror", "fa"),
        confirmButtonText: getText("ok", "fa"),
      });
    }
  };
  return (
    <DashboardLayout>
      <DashboardNavbar
        title={getText("questions", "fa")}
        // searchHandler={searchHandler}
      />
      <div className={"fa" === "en" ? "listmenu" : "listmenu rtl"}>
        {/* <div style={{ width: "100%", height: 45 }} ref={myRef}></div> */}
        {menu && newMenu()}

        {menu && controller.id !== "" && renderSettingsMenu()}
        {menu && controller.id == "" && (
          <>
            <ListItem
              style={{
                height: 50,
                cursor: "pointer",
                backgroundColor: open2
                  ? "RGBA(176, 176, 176, 0.7)"
                  : "transparent",
              }}
              onClick={() => {
                navigate("/authentication/sign-in", { replace: true });
              }}
              button
            >
              <ListItemText
                primary={
                  <Typography
                    variant="inherit"
                    style={{
                      color: "#039dfc",
                      fontSize: 14,
                      fontWeight: "bold",
                    }}
                  >
                    {getText("login", "fa")}
                  </Typography>
                }
              />
            </ListItem>
            <Divider />
          </>
        )}

        {searchDisplay && (
          // <Paper component="form" className={classes.root}>
          <Paper
            component="form"
            style={{
              padding: "1px 4px",
              display: "flex",
              alignItems: "center",
              margin: 0,
              left: 0,
              with: "100% !important",
              right: 0,
              bottom: 39,
              position: "fixed",
              borderRadius: 0,
              backgroundColor: "#ffc7d4",
              zIndex: 9999,
            }}
          >
            <IconButton
              color="primary"
              // className={classes.iconButton}
              aria-label="HighlightOffIcon"
              onClick={() => {
                setSearch("");
                setSearchDisplay(false);
                setMenu(JSON.parse(SourceMenu));
                // createMenu(selectedItem, controller.favorite, '');
              }}
            >
              <HighlightOffIcon />
            </IconButton>
            <InputBase
              // className={classes.input}
              value={search}
              fullWidth={true}
              autoFocus={true}
              onChange={(event) => {
                setSearch(event.target.value);
                if (event.target.value.length > 0) {
                  let smenu = JSON.parse(SourceMenu);

                  // smenu = SourceMenu.filter((a) =>
                  //     a.text.toLowerCase().includes(event.target.value.toLowerCase())
                  // );
                  let value = event.target.value.toLowerCase();
                  console.log(value, smenu);
                  smenu.map((item, index) => {
                    if (item.id !== "files") {
                      item.title.map((sitem, sindex) => {
                        sitem.capsule = sitem.capsule.filter((a) =>
                          a.text.toLowerCase().includes(value)
                        );
                      });
                    }
                    // item.title = item.title.filter((a) =>
                    //   a.text.toLowerCase().includes(value)
                    // );
                    // if (item.title.text.toLowerCase().includes(event.target.value.toLowerCase())){

                    // }
                  });

                  setMenu(smenu);
                  setReload(new Date());
                } else {
                  setMenu(JSON.parse(SourceMenu));
                }
              }}
            />

            <IconButton
              color="primary"
              // className={classes.iconButton}
              aria-label="search"
            >
              <SearchIcon />
            </IconButton>
          </Paper>
        )}
      </div>
      <Footer />
    </DashboardLayout>
  );
}
